import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    markdown: {
        '& h1': {
            fontSize: '1.5rem',
            fontWeight: 700,
            color: theme.palette.primary.main,
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
        },
        '& h2': {
            fontSize: '1.3rem',
            fontWeight: 700,
            color: theme.palette.primary.main,
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
        },
        '& h3': {
            fontSize: '1.1rem',
            fontWeight: 600,
            color: theme.palette.primary.main,
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
        },
        '& h4': {
            fontSize: '1rem',
            fontWeight: 600,
            color: theme.palette.primary.main,
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
        },
        '& h5': {
            fontSize: '0.9rem',
            fontWeight: 600,
            color: theme.palette.primary.main,
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
        },
        '& h6': {
            fontSize: '0.8rem',
            fontWeight: 600,
            color: theme.palette.primary.main,
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
        },
        '& p': {
            marginBottom: theme.spacing(2),
            lineHeight: 1.7,
            color: theme.palette.text.primary,
        },
        '& strong': {
            fontWeight: 600,
            color: theme.palette.primary.main,
        },
        '& a': {
            color: theme.palette.secondary.main,
            textDecoration: 'none',
            fontWeight: 500,
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        '& ul, & ol': {
            paddingLeft: theme.spacing(3),
            marginBottom: theme.spacing(2),
            '& li': {
                marginBottom: theme.spacing(0.5),
                lineHeight: 1.6,
            },
        },
        '& ul': {
            listStyleType: 'disc',
        },
        '& ol': {
            listStyleType: 'decimal',
        },
        '& table': {
            width: '100%',
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            borderCollapse: 'collapse',
            backgroundColor: 'rgba(27, 21, 74, 0.05)',
            borderRadius: theme.spacing(1),
            overflow: 'hidden',
        },
        '& td, & th': {
            padding: theme.spacing(1.5),
            borderBottom: '1px solid rgba(27, 21, 74, 0.1)',
            textAlign: 'left',
            '&:last-child': {
                borderBottom: 'none',
            },
        },
        '& th': {
            backgroundColor: 'rgba(27, 21, 74, 0.1)',
            fontWeight: 600,
            color: theme.palette.primary.main,
        },
        '& code': {
            backgroundColor: 'rgba(27, 21, 74, 0.05)',
            padding: theme.spacing(0.5, 1),
            borderRadius: theme.spacing(0.5),
            fontSize: '0.9rem',
            fontFamily: 'monospace',
        },
        '& pre': {
            backgroundColor: 'rgba(27, 21, 74, 0.05)',
            padding: theme.spacing(2),
            borderRadius: theme.spacing(1),
            overflow: 'auto',
            marginBottom: theme.spacing(2),
            '& code': {
                backgroundColor: 'transparent',
                padding: 0,
            },
        },
        '& blockquote': {
            borderLeft: `4px solid ${theme.palette.secondary.main}`,
            paddingLeft: theme.spacing(2),
            marginLeft: 0,
            marginBottom: theme.spacing(2),
            fontStyle: 'italic',
            color: theme.palette.text.secondary,
        },
    },
}));
